import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  ITask,
  TaskState,
  TaskType,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class Task extends BaseModel<Task, 'Task'> implements ITask {
  static override readonly modelName: AbilitySubjectType = 'Task';

  @Type(() => Date)
  planStart?: Date | null;
  @Type(() => Date)
  planEnd?: Date | null;
  groupId?: string;
  userId?: string;

  apId?: string;
  customerId?: number;
  customerNo?: string;
  city?: string;
  address?: string;
  customerName?: string;

  description?: string;
  type!: TaskType;

  maintenanceType?: string;
  subtaskType?: string;

  @Type(() => Date)
  contactClientUntil?: Date;

  @Type(() => Date)
  connectUntil?: Date;

  state!: TaskState;
  extId?: string;
  assumedAction!: string | null;
  performedAction!: string | null;

  isActive!: boolean;
}
